/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Footer_PagesInputs */

const en_portal_footer_pages = /** @type {(inputs: Portal_Footer_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this page`)
};

const pl_portal_footer_pages = /** @type {(inputs: Portal_Footer_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na tej stronie`)
};

/**
* | output |
* | --- |
* | "On this page" |
*
* @param {Portal_Footer_PagesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_footer_pages = /** @type {((inputs?: Portal_Footer_PagesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Footer_PagesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_footer_pages(inputs)
	return en_portal_footer_pages(inputs)
});